/**
 * 微信开放平台「移动应用」AppID（`wx-open-launch-app` 的 `appid`，与 JS-SDK 签名里的公众号 appId 可为同一应用视主体配置而定）。
 * 可通过环境变量 `VUE_APP_WECHAT_OPEN_LAUNCH_APP_ID` 覆盖。
 * @type {string}
 */
const DEFAULT_WECHAT_OPEN_LAUNCH_APP_ID = 'wx7e5866919435b0b2';

export const WECHAT_OPEN_LAUNCH_APP_ID =
  (typeof process !== 'undefined' && process.env && process.env.VUE_APP_WECHAT_OPEN_LAUNCH_APP_ID) ||
  DEFAULT_WECHAT_OPEN_LAUNCH_APP_ID;
